/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2022 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { resolve } from "path";

/* ---------------------- Paths ---------------------- */

// eslint-disable-next-line no-undef
export const MAIN_ROOT = resolve(`${__dirname}/../../..`);

/* ---------------------- Time ---------------------- */

export const ONE_SECOND = 1000;

export const ONE_MINUTE = 60 * ONE_SECOND;

export const ONE_HOUR = 60 * ONE_MINUTE;

export const ONE_DAY = 24 * ONE_HOUR;

/* --------------------- Errors ---------------------- */
export const INVITE_CLAIMED_ERROR = "Token already registered";

export const FIRST_PAGE_TITLE = "README";

export const DEFAULT_PAGE_WIDTH = 1200;
export const DEFAULT_PAGE_HEIGHT = 2000;

export const SOCKET_UNAUTHORIZED = "not authorized";

// client block fields that do not exist in the database
export const ILLEGAL_BLOCK_FIELDS = ["uploadPercent", "numberOfEmbeds", "newCoordinates", "connections"];

// fields that are not allowed to be set by the client
export const READ_ONLY_CLIENT_BLOCK_FIELDS = [
  // should not be updated by client
  "updatedAt",
  "createdAt",
  // relations
  "embeddedBlock",
  "BlockEmbeddings",
  "page",
  "user",
  "likedBy",
  "Activity",
];
